import styled from 'styled-components';

import { breakpoints } from '../../constants';

export const ControlsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    @media (${breakpoints.mediumMin}) {
        box-sizing: content-box;
    }
`;
